import { Badge, Box, IconButton, Tooltip } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter as faFilterLight } from "@fortawesome/pro-light-svg-icons"
import { faFilter as faFilterRegular } from "@fortawesome/pro-regular-svg-icons"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

type StyleProps = Readonly<{ bordered: boolean }>

const useStyles = makeStyles<StyleProps>()((theme, { bordered }) => ({
    button: {
        padding: ".75rem",
        borderRadius: ".75rem",
        color: theme.palette.action.active,
        width: "2.5rem",
        height: "2.5rem",
        ...(bordered && {
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
        }),
    },
    badge: {
        "& .MuiBadge-badge": {
            backgroundColor: tailwindPalette.slate[900],
            color: theme.palette.common.white,
        },
    },
}))

type StandardFilterButtonProps = Readonly<{
    onClick: () => void
    activeCount: number
    className?: string
    bordered?: boolean
}>

export const StandardFilterButton = ({ onClick, activeCount, className, bordered = false }: StandardFilterButtonProps) => {
    const { classes, cx } = useStyles({ bordered })

    return (
        <LocalizedStrict id="table-filters-button" attrs={{ title: true }}>
            <Tooltip title="Filters">
                <Box component="span">
                    <Badge badgeContent={activeCount} invisible={!activeCount} overlap="circular" className={classes.badge}>
                        <LocalizedStrict id="table-filters-button" attrs={{ "aria-label": true }}>
                            <IconButton className={cx(classes.button, className)} onClick={onClick} aria-label="Filters">
                                <FontAwesomeIcon icon={bordered ? faFilterLight : faFilterRegular} size="xs" />
                            </IconButton>
                        </LocalizedStrict>
                    </Badge>
                </Box>
            </Tooltip>
        </LocalizedStrict>
    )
}
